import * as React from 'react';
import Modal from 'react-bootstrap4-modal';
import LesImagesUpload from './upload';
import LesImagesImport from './import';

export default class LesImages extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      opened: false,
      selectedImages: {},
      activeTab: 'import',
    };

    this.finish = this.finish.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.isImageSelected = this.isImageSelected.bind(this);
    this.selectImages = this.selectImages.bind(this);
  }

  public render() {
    return (
      <div>
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={() => {
            this.setState({ selectedImages: {} });
            this.toggleModal();
          }}
        >
          Importar imagenes
        </button>
        <Modal visible={this.state.opened} onClickBackdrop={this.toggleModal} dialogClassName="modal-lg">
          <div className="modal-header">
            <h5 className="modal-title">Importar imagenes</h5>
          </div>
          <div className="modal-body">
            <div className="row mb-3">
              <div className="col">
                <ul className="nav nav-tabs nav-fill">
                  <li className="nav-item">
                    <a
                      className={this.state.activeTab === 'import' ? 'nav-link active' : 'nav-link'}
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ activeTab: 'import' });
                      }}
                    >
                      <i className="fa fa-download"></i> Importar
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={this.state.activeTab === 'upload' ? 'nav-link active' : 'nav-link'}
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ activeTab: 'upload' });
                      }}
                    >
                      <i className="fa fa-upload"></i> Cargar nuevas
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {
              this.state.activeTab === 'import' &&
              <LesImagesImport
                isImageSelected={this.isImageSelected}
                selectImages={this.selectImages}
              />
            }
            {
              this.state.activeTab === 'upload' &&
              <LesImagesUpload
                onUploadFinished={(images: any[]) => {
                  this.selectImages(images);

                  this.finish();
                }}
              />
            }
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault();

                this.finish();
              }}
            >
              Importar seleccionadas
            </button>
            <button type="button" className="btn btn-danger" onClick={this.toggleModal}>
              Cancelar
            </button>
          </div>
        </Modal>
      </div>
    )
  }

  private isImageSelected(image: any) {
    return this.state.selectedImages[image._id];
  }

  private selectImages(images: any[]) {
    const selectedImages = Object.assign({}, this.state.selectedImages);;

    images.forEach((image: any) => {
      if (this.isImageSelected(image)) {
        delete selectedImages[image._id];
      } else {
        selectedImages[image._id] = image;
      }
    });

    this.setState({ selectedImages });
  }

  private finish() {
    const images: any = Object.keys(this.state.selectedImages).map((key: string) => {
      return this.state.selectedImages[key];
    });

    this.props.onSelected(images);
    this.toggleModal();
  }

  private toggleModal() {
    this.setState({ opened: !this.state.opened });
  }
}



// WEBPACK FOOTER //
// ./src/containers/Shared/Images/index.tsx